import _ from 'lodash'

export default (targetString, searchString) => {
  const search = searchString.toLowerCase().replace(/\s/g, '')
  const target = targetString.toLowerCase().replace(/\s/g, '')
  return _.includes(target, search)
}
